import React, { useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { top, center, centerPoint, last, lastpoint } from "../data/Value";
import CreateView from "./CreateView";
import folderIcon from "../Assets/folder.png";
import PdfIcon from "../Assets/PdfIcon.png";
import Excel from "../Assets/Excel.png";
import video from "../Assets/video.png";
import { toast } from "react-toastify";
import { IoIosArrowDropright } from "react-icons/io";

const Sidebar = ({
  sidebarOpen,
  setSidebarOpen,
  files,
  setFiles,
  isCreateModalOpen,
  setIsCreateModalOpen,
  fileType,
  setFileType,
  fileInput,
  setFileInput,
  isLoading,
  setIsLoading,
  currentFolder,
  setCurrentFolder,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const sidebarRef = useRef();

  const isActive = (path) => location.pathname === path;

  const allowedExtensions = [
    "jpg", "jpeg", "png", "gif", "bmp", "webp", "mp4", "mov", "avi", "mkv",
    "wmv", "flv", "mp3", "wav", "m4a", "aac", "pdf", "doc", "docx", "xls", "xlsx"
  ];

  const handleCreate = () => {
    setIsLoading(true);
    setTimeout(() => {
      if (fileType === "File" && fileInput) {
        const ext = fileInput.name.split(".").pop().toLowerCase();
        if (!allowedExtensions.includes(ext)) {
          alert("Invalid file type...");
          setIsLoading(false);
          return;
        }

        let iconUrl;
        const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
        const videoExtensions = ["mp4", "mov", "avi", "mkv", "wmv", "flv"];
        const excelExtensions = ["xls", "xlsx"];

        if (imageExtensions.includes(ext)) iconUrl = URL.createObjectURL(fileInput);
        else if (videoExtensions.includes(ext)) iconUrl = video;
        else if (ext === "pdf") iconUrl = PdfIcon;
        else if (excelExtensions.includes(ext)) iconUrl = Excel;

        const newFileItem = {
          id: Date.now(),
          name: fileInput.name.slice(0, 4) + "...",
          updatedAt: new Date().toLocaleString(),
          icon: iconUrl,
          FileType: "File",
          isDirectory: false,
          originalName: fileInput.name,
          extension: ext,
        };

        if (currentFolder) {
          currentFolder.items.unshift(newFileItem);
          setFiles([...files]);
        } else {
          setFiles([newFileItem, ...files]);
        }

        if (imageExtensions.includes(ext)) navigate("/photos");
        else if (videoExtensions.includes(ext)) navigate("/videos");
      } else if (fileType === "Folder") {
        const folderCount = files.filter(f => f.FileType === "Folder").length + 1;
        const newFolder = {
          id: Date.now(),
          name: `New Folder ${folderCount}`,
          updatedAt: new Date().toLocaleString(),
          icon: folderIcon,
          FileType: "Folder",
          isDirectory: true,
          filecount: 0,
          items: [],
        };

        if (currentFolder) {
          currentFolder.items.unshift(newFolder);
          currentFolder.filecount += 1;
          setFiles([...files]);
        } else {
          setFiles([newFolder, ...files]);
        }

        navigate(`/fileList/${newFolder.id}`);
        toast.success("Folder created!");
      }

      setFileInput(null);
      setIsCreateModalOpen(false);
      setIsLoading(false);
    }, 1000);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        window.innerWidth < 768
      ) {
        setSidebarOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <aside
      ref={sidebarRef}
      className={`fixed top-0 left-0 z-auto  h-full w-60 bg-four px-4 py-1   transition-transform duration-300 ease-in-out
        ${sidebarOpen ? "translate-x-0" : "-translate-x-full"} 
        md:translate-x-0 md:static md:block overflow-y-auto
      `}
    >
      {/* Logos */}
      <div className="flex justify-center items-center gap-3 mt-3">
        <div className="w-16 p-1 bg-white rounded-md shadow-md">
          <img src="/assets/logo.png" alt="Logo" className="w-full h-auto" />
        </div>
        <div className="w-20">
          <img src="/assets/azero.png" alt="Azero" className="w-full h-auto" />
        </div>
        <div>
          <IoIosArrowDropright/>
        </div>
      </div>

      {/* Navigation */}
      <div className="flex flex-col space-y-3 mt-5 ">
        <Section items={top} isActive={isActive} navigate={navigate} setSidebarOpen={setSidebarOpen} />
        <Section items={center} isActive={isActive} navigate={navigate} setSidebarOpen={setSidebarOpen} />
        <Section items={centerPoint} isActive={isActive} navigate={navigate} setSidebarOpen={setSidebarOpen} />
        <Section items={last} isActive={isActive} navigate={navigate} setSidebarOpen={setSidebarOpen} />
        <Section items={lastpoint} isActive={isActive} navigate={navigate} setSidebarOpen={setSidebarOpen} />
      </div>

      <div>
  {/* STORAGE SECTION WRAPPER */}
<div className=" mt-20">
  <div className="w-52 bg-white rounded-xl p-3 shadow-md border border-gray-100">

    {/* Scrollable inner area */}
    <div className="max-h-44  custom-scroll pr-1">

      {/* STORAGE CARD */}
      <div className="bg-third  border border-orange-200 rounded-lg p-4 shadow-sm  ">

        {/* Title */}
        <div className="flex items-center gap-2 mb-3">
          <span className="text-xl">☁️</span>
          <span className="text-primary font-semibold text-sm">
            Storage
          </span>
        </div>

        {/* Progress bar */}
        <div className="w-full bg-orange-200 rounded-full h-2">
          <div
            className="h-2 rounded-full bg-orange-500 transition-all duration-500"
            style={{ width: "55%" }}
          ></div>
        </div>

        {/* Used/Total text */}
        <p className="text-xs text-primary mt-2">
          <span className="font-semibold">500GB</span> of 900GB used
        </p>

        {/* Button */}
        <button className="w-full mt-3 bg-primary text-white text-xs py-1.5 rounded-md font-medium  transition">
          Upgrade Storage
        </button>
      </div>

      
     

     
     {/*  <div className="flex items-center gap-2 p-2 rounded-lg cursor-pointer text-gray-700 hover:bg-gray-100 transition">
        <span className="text-lg">❓</span>
        <span className="text-[13px] font-medium">Help & Guide</span>
      </div>
 */}
    </div>
  </div>
</div>



      </div>

      {/* Create Modal */}
      {isCreateModalOpen && (
        <CreateView
          files={files}
          setFiles={setFiles}
          currentFolder={currentFolder}
          setIsCreateModalOpen={setIsCreateModalOpen}
          fileType={fileType}
          setFileType={setFileType}
          fileInput={fileInput}
          setFileInput={setFileInput}
          handleCreate={handleCreate}
          isLoading={isLoading}
        />
      )}
    </aside>
  );
};

const Section = ({ items, isActive, navigate, setSidebarOpen }) => (
  <div className="">
    {items.map((item, index) => (
      <div
        key={item.id || index}
        onClick={() => {
          navigate(item.path);
          setSidebarOpen(false);
        }}
        className={`flex items-center gap-3 font-medium cursor-pointer px-2 py-2  rounded-md text-sm transition-all duration-200
          ${isActive(item.path)
            ? "bg-third text-primary"
            : "text-secondary hover:bg-gray-100"}
        `}
      >
        <span className="text-lg">{item.icon}</span>
        <span className="truncate">{item.name}</span>
      </div>
    ))}
  </div>
);

export default Sidebar;
